import React, { Component, Fragment } from "react";
import Chart from "react-apexcharts";
import { CSVLink } from "react-csv";
import { MdShowChart } from "react-icons/md";
import LoadingOverlay from "react-loading-overlay";
import { connect } from "react-redux";
import { firebaseConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Button, Col, FormGroup, FormSelect, Row } from "shards-react";
import categories from "./categories.json";
// import graphData from './complaints.json';
import sectors from "./sectors.json";

const mapState = (state, ownProps) => {
  const graphData = state.firebase.data.graphData;
  const year = new Date().getFullYear();
  const segment = ownProps.segment;

  return {
    graphData,
    year,
    segment,
  };
};

const actions = {};

const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

class Timeline extends Component {
  state = {
    headers: [
      { label: "Month", key: "month" },
      { label: "Total Tickets", key: "total" },
    ],
    csvData: [],
    queryString: null,
    versus: [],
    chartType: "line",
    chartTitle: "",
    queryYear: new Date().getFullYear(),
    querySector: "",
    options: {
      chart: {
        id: "basic-bar",
        background: "#f4f4f4",
        foreColor: "#333",
      },

      animations: {
        enabled: true,
        easing: "easeinout",
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150,
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
      },

      xaxis: {
        type: "datetime",
      },
      yaxis: {
        title: {
          text: "tickets",
        },
      },
    },
    seriesBar: [],
    series: [],
    labels: [],
    selection: this.props.segment,
  };

  componentDidMount() {
    this.setState({ loading: true });
    setTimeout(() => {
      this.updateCharts();
    }, 2000);
  }

  handleSelectChange(e) {
    this.setState({ queryString: e.target.value, loading: true });

    if (e.target.value === "sectors") {
      this.setState({ querySector: "" });
    }

    if (e.target.name === "sector") {
      this.setState({ querySector: e.target.value, loading: true });
    }

    setTimeout(() => {
      this.updateCharts();
    }, 1000);
  }

  updateCharts() {
    let newGraphSeries = [];
    let data = [];
    let csvData = [];
    let payload = [];

    if (!this.state.queryYear) {
      this.setState({ queryYear: this.state.queryYear });
    }

    data = this.state.graphData.filter(
      (document) => document.date.year === this.state.queryYear
    );

    if (!this.state.queryString) {
      monthNames.forEach((month, index) => {
        if (!newGraphSeries[this.state.queryYear]) {
          newGraphSeries[this.state.queryYear] = [];
        }
        let monthCount = data.filter(
          (document) => document.date.month === index
        ).length;
        let datestamp = new Date(this.state.queryYear, index);
        newGraphSeries[this.state.queryYear].push([
          datestamp.getTime(),
          monthCount,
        ]);
        csvData.push({ month: month, total: monthCount });
      });
      payload.push({
        name: "total-ticket",
        type: this.state.chartType,
        data: newGraphSeries[this.state.queryYear],
      });

      //set title for total tickets
      let title = `Total complaints received in ${this.state.queryYear}`;
      this.setState({ chartTitle: title });
    } else {
      if (!newGraphSeries[this.state.queryYear]) {
        newGraphSeries[this.state.queryYear] = [];
      }

      switch (this.state.queryString) {
        case "sectors":
          this.setState({
            headers: [
              { label: "Sector", key: "sector" },
              { label: "Month", key: "month" },
              { label: "Total Tickets", key: "total" },
            ],
          });
          sectors.forEach((sector) => {
            let sectorPayload = [];
            monthNames.forEach((month, index) => {
              let monthCount = data.filter(
                (document) =>
                  document.date.month === index &&
                  document.sectors.includes(sector)
              ).length;

              let datestamp = new Date(this.state.queryYear, index);
              sectorPayload.push([datestamp.getTime(), monthCount]);

              csvData.push({
                sector: sector,
                month: month,
                total: monthCount,
              });
            });
            payload.push({
              name: sector,
              type: this.state.chartType,
              data: sectorPayload,
            });
          });

          break;

        case "categories":
          this.setState({
            headers: [
              { label: "Sector", key: "sector" },
              { label: "Month", key: "month" },
              { label: "Total Tickets", key: "total" },
            ],
          });
          categories.forEach((sector) => {
            let sectorPayload = [];
            monthNames.forEach((month, index) => {
              let monthCount = data.filter(
                (document) =>
                  document.date.month === index &&
                  document.sectors.includes(sector)
              ).length;
              let datestamp = new Date(this.state.queryYear, index);
              sectorPayload.push([datestamp.getTime(), monthCount]);

              csvData.push({
                sector: sector,
                month: month,
                total: monthCount,
              });
            });
            payload.push({
              name: sector,
              type: this.state.chartType,
              data: sectorPayload,
            });
          });

          break;

        default:
          break;
      }

      //  if Sectors are selected, load graph data of the particular sector

      if (this.state.querySector !== "") {
        let cats = categories.filter(
          (document) => document.sector === this.state.querySector
        );
        this.setState({
          headers: [
            { label: "Sector", key: "sector" },
            { label: "Month", key: "month" },
            { label: "Total Tickets", key: "total" },
          ],
        });
        cats.forEach((category) => {
          let categoryPayload = [];
          monthNames.forEach((month, index) => {
            let monthCount = data.filter(
              (document) =>
                document.date.month === index &&
                document.sectors.includes(this.state.querySector) &&
                document.categories.includes(category.name)
            ).length;
            let datestamp = new Date(this.state.queryYear, index);
            categoryPayload.push([datestamp.getTime(), monthCount]);

            csvData.push({
              category: category,
              month: month,
              total: monthCount,
            });
          });
          payload.push({
            name: category.name,
            type: this.state.chartType,
            data: categoryPayload,
          });
        });
      }
    }

    this.setState({
      options: { ...this.state.options },
      series: payload,
      csvData: csvData,
      loading: false,
    });
  }

  handleVersus(e) {
    let versusArray = this.state.versus || [];
    versusArray.push(e.target.value);
    this.setState({ versus: versusArray, loading: true });

    setTimeout(() => {}, 1000);
  }

  render() {
    return (
      <Fragment>
        <LoadingOverlay active={this.state.loading} spinner>
          <Row>
            <Col>
              <FormGroup>
                <label htmlFor="chartType">ChartType</label>
                <FormSelect
                  name="chartType"
                  value={this.state.chartType}
                  onChange={(e) => {
                    this.setState({ chartType: e.target.value, loading: true });
                    setTimeout(() => {
                      this.updateCharts();
                    }, 1000);
                  }}
                >
                  <option value="line">Line</option>
                  <option value="bar">Bar</option>
                </FormSelect>
              </FormGroup>
            </Col>
            <Col>
              <Button onClick={() => this.updateCharts()}>
                <MdShowChart />
                Plot
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <label htmlFor="query">Query</label>
                <FormSelect
                  name="query"
                  value={this.state.queryString}
                  onChange={(e) => this.handleSelectChange(e)}
                >
                  <option value="">None</option>
                  <option value="sectors">Sectors</option>
                </FormSelect>
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <label htmlFor="query">Query</label>
                <FormSelect
                  name="sector"
                  value={this.state.querySector}
                  onChange={(e) => this.handleSelectChange(e)}
                >
                  <option value="">None</option>
                  {sectors.map((sector) => {
                    return <option value={sector}>{sector}</option>;
                  })}
                </FormSelect>
              </FormGroup>
            </Col>
          </Row>
          Or
          <Row>
            <Col>
              <FormGroup>
                <label htmlFor="query">Sector 1</label>
                <FormSelect
                  name="sector1"
                  value={this.state.versus[0]}
                  onChange={(e) => this.handleVersus(e)}
                >
                  <option value="">None</option>
                  {sectors.map((sector) => {
                    return <option value={sector}>{sector}</option>;
                  })}
                </FormSelect>
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <label htmlFor="query">Sector 2</label>
                <FormSelect
                  name="sector2"
                  value={this.state.versus[0]}
                  onChange={(e) => this.handleVersus(e)}
                >
                  <option value="">None</option>
                  {sectors.map((sector) => {
                    return <option value={sector}>{sector}</option>;
                  })}
                </FormSelect>
              </FormGroup>
            </Col>
          </Row>
          <h4 className="text-center mt-2"> {this.state.chartTitle}</h4>
          <Chart
            options={this.state.options}
            series={this.state.series}
            height="600"
          />
          {this.state.series.length > 0 ? (
            <CSVLink
              filename={this.state.queryYear + "_total_tickets.csv"}
              className="btn btn-primary mx-auto"
              data={this.state.csvData}
              headers={this.state.headers}
              target="_blank"
            >
              Download CSV
            </CSVLink>
          ) : (
            ""
          )}
          {/* <table className='table mb-0'>
          <thead className='bg-light'>
            <tr>
              <th scope='col' className='border-0 text-capitalize'>
                {this.props.segment}
              </th>
              <th scope='col' className='border-0'>
                Tickets
              </th>
            </tr>
          </thead>
          <tbody>
            {this.state.options.xaxis.categories &&
              this.state.series.length > 0 &&
              this.state.options.xaxis.categories.map((item, index) => {
                return (
                  <tr key={item}>
                    <td className='text-capitalize caption' key={item}>
                      {item}
                    </td>
                    <td key={item + index} className='caption'>
                      {this.state.series[0].data[index] || ''}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table> */}
        </LoadingOverlay>
      </Fragment>
    );
  }
}

export default compose(
  connect(mapState, actions),
  firebaseConnect([
    {
      path: "/graphData",
      storeAs: "graphData",
    },
  ])
)(Timeline);
